// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import './fieldViewer';

/**
 * Displays a download link for file fields
 * @name FileFieldViewer
 * @constructor
 * @extends {FieldViewer}
 */
myw.FileFieldViewer = myw.FieldViewer.extend({
    tagName: 'div',
    messageGroup: 'FileFieldEditor',
    render() {
        const displayValue = this.feature.displayValues[this.fieldName];

        if (!displayValue) return;

        const template = $('<a/>', {
            style: 'cursor:pointer;',
            html: displayValue,
            click: e => {
                e.preventDefault();
                this.beginDownload();
            }
        }).addClass('relationship');
        this.$el.html(template);
    },

    /**
     * Request lobs and then being download process
     * ENH:This is will cause a heavy request of getting all lobs
     */
    async beginDownload() {
        await this.feature.ensure('lobs');
        const { name, mime_type, content_base64 } = this.feature.properties[this.fieldName];
        this.app.system.executeBlobDownload(
            myw.Util.b64toBlob(content_base64, mime_type, 512),
            name,
            mime_type
        );
    }
});

export default myw.FileFieldViewer;
